<template>
	<div style="position: relative;">
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-row>
			<b-col cols="3">
				<b-card>
					<h3>
						Zones
						<b-button v-if="$hasPermission('zoneArea.add')" @click="addZone" size="sm" variant="success"
							><md-icon icon="add"
						/></b-button>
					</h3>
					<hr />
					<draggable
						v-model="zones"
						group="people"
						class="list-group"
						ghost-class="ghost"
						@start="drag = true"
						@end="drag = false"
						@change="onChange"
					>
						<div
							v-for="(zone, i) in zones"
							:key="i"
							class="list-group-item"
							v-bind:class="{ listItemActive: isSelect(zone) }"
							@click="selectZone(zone)"
						>
							<div class="zone-name">
								<b-form-input
								v-if="editingZoneNameIndex == i"
								type="text"
								v-model="zone.name"
								required/>
								<div v-else>{{ zone.name }}</div>
							</div>

							<div class="zone-priority">
								Prioridad: {{ zone.priority }}
							</div>



							<!-- Buttons edit -->
							<div class="button-actions">
								<b-input-group class="input-groups">
									<template #append>
										<b-button
											:disabled="!$hasPermission('zoneArea.edit')"
											@click="
												editingZoneNameIndex == -1
													? (editingZoneNameIndex = i)
													: onUpdateZoneName()
											"
											variant="success"
										>
											<md-icon
												v-if="editingZoneNameIndex != i"
												icon="edit"
											/>
											<md-icon v-else icon="save" />
										</b-button>
										<b-button
											:disabled="!$hasPermission('zoneArea.delete')"
											@click="deleteZone(i)"
											variant="danger"
											><md-icon icon="delete"
										/></b-button>
									</template>
								</b-input-group>
							</div>
						</div>
					</draggable>
				</b-card>
			</b-col>
			<b-col cols="7">
				<b-card>
					<h2 class="text-center">
						<template v-if="editingZone">
							Editing Zone: {{ editingZone.name }}<br />
							<small
								class="text-danger"
								v-if="editingZone.polygon == null"
								>Click to start delimiting a zone</small
							>
						</template>
					</h2>
					<div class="text-center">
						<input id="search-box" type="text" ref="search-box" />
					</div>
					<div id="zones-map" ref="map"></div>
				</b-card>
				<b-card v-if="editingZone">
					<h4>Coordenadas: <strong>{{editingZone.name}}</strong></h4>
					<b-table
						striped
						:fields="['#','latitude','longitude']"
						:items="editingZonePoints"
						style="color:#fff"
					>
						<template #cell(latitude)="data">
							<b-button @click="$root.copyToClipboard(data.item.latitude)" variant="primary" size="sm"><md-icon icon="content_copy" /></b-button> {{data.item.latitude}}
						</template>
						<template #cell(longitude)="data">
							<b-button @click="$root.copyToClipboard(data.item.longitude)" variant="primary" size="sm"><md-icon icon="content_copy" /></b-button> {{data.item.longitude}}
						</template>

						<template #cell(#)="data">
							{{ data.index + 1 }}
						</template>
					</b-table>
				</b-card>
			</b-col>
			<b-col cols="2">
				<b-card>
					<b-button :disabled="!$hasPermission('zoneArea.edit')" @click="onSave" variant="success" size="lg" block
						><md-icon icon="save" /><br />Save</b-button
					>
					<hr />
					<b-button
						@click="$emit('reFetch')"
						variant="warning"
						size="lg"
						block
						><md-icon icon="restore" /><br />Restore</b-button
					>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import draggable from "vuedraggable";

export default {
	props: {
		zonedArea: {
			type: Object,
			required: true
		}
	},
	components: { draggable },
	data() {
		return {
			firstFetch: true,
			zones: [],
			loading: true,
			map: null,
			drawingManager: null,
			editingZone: null,
			editingZoneNameIndex: -1,
			hackUpdateCoords: 0,
			polygonEditableOpts: {
				drawingControl: true,
				strokeColor: "#3fb618",
				fillColor: "#3fb618",
				editable: true,
				draggable: true
			},
			polygonNotEditableOpts: {
				drawingControl: false,
				strokeColor: "#dc3545",
				fillColor: "#dc3545",
				editable: false,
				draggable: false
			}
		};
	},
	computed: {
		editingZonePoints(){
			this.hackUpdateCoords
			if (this.editingZone !== null) {
				return this.editingZone.polygon
					.getPath()
					.getArray()
					.map(path => ({
						latitude: path.lat(),
						longitude: path.lng()
					}))
			}
			return []
		}
	},
	methods: {
		onChange () {
			this.zones.forEach( (e, i) => {
				e.priority = 100 - i;
			});
		},
		isSelect(zone) {
			if (this.editingZone) {
				return this.editingZone.id === zone.id;
			}
			return false;
		},
		onUpdateZoneName() {
			if (this.zones[this.editingZoneNameIndex].infoWindow) {
				this.zones[this.editingZoneNameIndex].infoWindow.setOptions({
					content: this.zones[this.editingZoneNameIndex].name
				});
			}
			this.editingZoneNameIndex = -1;
		},
		addZone() {
			this.zones.push({
				id: -1,
				name: `ZONE ${this.zones.length + 1}`,
				polygon: null,
				infoWindow: null,
				priority: 100 - this.zones.length
			});
			this.selectZone(this.zones[this.zones.length - 1]);
		},
		deleteZone(index) {
			this.drawingManager.setMap(null);
			if (this.zones[index].id == -1) {
				// elimina zona no guardada
				if (this.zones[index].polygon)
					this.zones[index].polygon.setMap(null);
				if (this.zones[index].infoWindow)
					this.zones[index].infoWindow.close();

				this.zones.splice(index, 1);
			} else {
				this.$root.showWarning({
					message:
						"Esta zona ya ha sido guardada en el sistema, si eliminas una zona se eliminaran todos los costos cargados para dicha zona.",
					okAction: (event, setLoading, close) => {
						// elimina zona que ya existia en la DB
						setLoading(true);
						this.$root.api
							.delete(`/zones/${this.zones[index].id}`)
							.then(() => {
								this.$root.showAlert("Zona eliminada!", {
									variant: "warning"
								});
								if (this.zones[index].polygon)
									this.zones[index].polygon.setMap(null);
								if (this.zones[index].infoWindow)
									this.zones[index].infoWindow.close();
								this.zones.splice(index, 1);
								close();
							})
							.catch(err => {
								this.$root.handleRequestError(err);
								close();
							});
					}
				});
			}
		},
		selectZone(zone) {
			this.editingZone = zone;
			// si es zona nueva, inicia la funcion de dibujo
			this.blockPolygons();
			if (this.editingZone.polygon == null)
				this.drawingManager.setMap(this.map);
			//habilita la creacion de poligono
			else {
				// si ya existe, solo la habilita para edición
				this.drawingManager.setMap(null); //quita la creacion de poligono
				this.editingZone.polygon.setOptions(this.polygonEditableOpts);
			}
		},
		blockPolygons() {
			this.zones.forEach(zone => {
				if (zone.polygon) {
					zone.polygon.setOptions(this.polygonNotEditableOpts);
				}
			});
		},
		getCentroid(polygon) {
			let PI = 22 / 7;
			let X = 0;
			let Y = 0;
			let Z = 0;
			polygon.getPath().forEach(function(vertex) {
				let lat1 = vertex.lat();
				let lon1 = vertex.lng();
				lat1 = (lat1 * PI) / 180;
				lon1 = (lon1 * PI) / 180;
				X += Math.cos(lat1) * Math.cos(lon1);
				Y += Math.cos(lat1) * Math.sin(lon1);
				Z += Math.sin(lat1);
			});
			let Lon = Math.atan2(Y, X);
			let Hyp = Math.sqrt(X * X + Y * Y);
			let Lat = Math.atan2(Z, Hyp);
			Lat = (Lat * 180) / PI;
			Lon = (Lon * 180) / PI;
			return new window.google.maps.LatLng(Lat, Lon);
		},
		initZones(zones) {
			let priority = 100;
			this.zones = zones.map(zone => {
				let polygon = this.createPolygon(zone.zoneGeoPoints);
				let infoWindow = this.createInfoWindow(zone.name, polygon);
				let auxZone = {
					id: zone.id,
					name: zone.name,
					priority: priority,
					polygon,
					infoWindow
				};
				priority = priority - 1;
				this.setZonePolygonEvents(auxZone);
				return auxZone;
			});
		},
		createPolygon(geoPoints) {
			let polygone = new window.google.maps.Polygon({
				paths: geoPoints.map(gp => ({
					lat: parseFloat(gp.latitude),
					lng: parseFloat(gp.longitude)
				})),
				...this.polygonNotEditableOpts
			});
			polygone.setMap(this.map);
			return polygone;
		},
		setZonePolygonEvents(zone) {
			zone.polygon.addListener("mouseup", () => {
				this.hackUpdateCoords++
			});
			zone.polygon.addListener("drag", () => {
				zone.infoWindow.close();
			});
			zone.polygon.addListener("dragend", () => {
				zone.infoWindow.setOptions({
					position: this.getCentroid(zone.polygon)
				});
			});
			zone.polygon.addListener("dblclick", event => {
				event.stop();
				this.selectZone(zone);
			});
			zone.polygon.addListener("rightclick", event => {
				if (event.vertex == undefined) return;
				zone.polygon.getPath().removeAt(event.vertex);
			});
		},
		createInfoWindow(zoneName, polygon) {
			return new window.google.maps.InfoWindow({
				content: zoneName,
				position: this.getCentroid(polygon)
			});
		},
		initMap() {
			this.map = new window.google.maps.Map(this.$refs["map"], {
				center: { lat: 21.1214886, lng: -86.9192742 },
				zoom: 8,
				streetViewControl: false
			});

			let searchBox = new window.google.maps.places.SearchBox(
				this.$refs["search-box"]
			);
			this.map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(
				this.$refs["search-box"]
			);
			this.map.addListener("bounds_changed", () => {
				searchBox.setBounds(this.map.getBounds());
			});
			searchBox.addListener("places_changed", () => {
				let places = searchBox.getPlaces();

				if (places.length == 0) {
					return;
				}

				// For each place, get the icon, name and location.
				var bounds = new window.google.maps.LatLngBounds();
				places.forEach(place => {
					if (!place.geometry) {
						console.log("Returned place contains no geometry");
						return;
					}
					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				this.map.fitBounds(bounds);
			});
			this.drawingManager = new window.google.maps.drawing.DrawingManager(
				{
					drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
					drawingControl: true,
					drawingControlOptions: {
						position: window.google.maps.ControlPosition.TOP_RIGHT,
						drawingModes: ["polygon", "rectangle"]
					}
				}
			);

			window.google.maps.event.addListener(
				this.drawingManager,
				"polygoncomplete",
				polygon => {
					polygon.setOptions(this.polygonEditableOpts);

					let infoWindow = this.createInfoWindow(
						this.editingZone.name,
						polygon
					);

					this.editingZone.polygon = polygon;
					this.editingZone.infoWindow = infoWindow;
					this.setZonePolygonEvents(this.editingZone);
					this.drawingManager.setMap(null);
				}
			);
		},
		loadZonedArea() {
			this.loading = true;
			this.resetMap();
			this.initZones(this.zonedArea.zones);
			if (this.firstFetch && this.zones.length > 0) {
				this.map.setCenter(this.getCentroid(this.zones[0].polygon));
				this.firstFetch = false;
			}
			this.loading = false;
		},
		resetMap() {
			this.editingZone = null;
			this.zones.forEach(zone => {
				if (zone.polygon) {
					zone.polygon.setOptions(this.polygonNotEditableOpts);
					zone.polygon.setMap(null);
				}
				if (zone.infoWindow) zone.infoWindow.close();
			});
		},
		onSave() {
			let query = {
				zones: this.zones
					.filter(zone => zone.polygon != null)
					.map(zone => {
						return {
							id: zone.id,
							name: zone.name,
							priority: zone.priority,
							geoPoints: zone.polygon
								.getPath()
								.getArray()
								.map(path => ({
									latitude: path.lat(),
									longitude: path.lng()
								}))
						};
					})
			};
			this.$root.api
				.put(`/zoned-areas/${this.$root.getParams().id}/zones`, query)
				.then(() => {
					this.$root.showAlert("Actualización exitosa");
					this.$emit("reFetch");
				})
				.catch(this.$root.handleRequestError);
		}
	},
	mounted() {
		this.initMap();
		this.loadZonedArea();
		// this.fetchModel()
	},
	watch: {
		zonedArea: function() {
			this.loadZonedArea();
			if (this.drawingManager) this.drawingManager.setMap(null);
		}
	}
};
</script>

<style scoped>
h2 {
	min-height: 40px;
}
#search-box {
	width: 100%;
	max-width: 400px;
	padding: 5px;
	font-size: 16px;
}
.zone-button {
	flex: 1;
}
.input-groups {
	width: 100%;
}
.list-group-item {
	color: #fff;
	background-color: #007bff;
	border-color: #007bff;
	margin-bottom: 5px;
	padding-right: 0;
	padding-top: 0;
	padding-bottom: 0;
	cursor: pointer;
}

.listItemActive {
	color: #212529;
	background-color: #ffc107;
	border-color: #ffc107;
	clear: both;
}

.button-actions {
	float: right;
}

.zone-name{
	margin-top: 10px;
	padding-bottom: 5px;
	padding-right: 12.8px;
}

.zone-priority {
	float: left;
	margin-top: 10px;
}

</style>
<style>
#zones-map {
	width: 100%;
	height: 500px;
}
</style>
